import { apiSlice } from './apiSlice.js';
import { FILES_URL } from '../constants.js';

export const filesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadDeliveryPartnerDocuments: builder.mutation({
      query: (formData) => ({
        url: `${FILES_URL}/uploaddeliverypartnerdocuments`,
        method: 'POST',
        body: formData
      }),
      invalidatesTags: ['Files']
    })
  })
});

export const {
  useUploadDeliveryPartnerDocumentsMutation
} = filesApiSlice;